import { Button, Card, CardContent, FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import MDButton from "components/MDButton";
import PageTitle from "examples/PageTitle/PageTitle";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { appConstants } from "utils/appConstants";
import { getScreenRight } from "utils/generic";
import DeleteModal from "components/deletemodal/deletemodal";
import TimelineItem from "components/Icon/TimelineItem";
import { useMaterialUIController } from "context";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import { useDispatch } from "react-redux";
import { fetchUser } from "utils/superAdminApi";
import { BTable } from "components/BTable/BTable";
import { GridSearchIcon } from "@mui/x-data-grid";
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { deleteUserRecords } from "utils/superAdminApi";
import { Link } from "react-router-dom";
import { loadingAction } from "ReduxReducers/loadingReducer";

let searchParameter = "";
let userStatus = "Active";
let LOGIN_DETAILS;

function Users() {
  const [customerReload, setCustomerReload] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [rows, setRows] = useState([]);
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [title, setTitle] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const dispatch = useDispatch();
  const [values, setValues] = useState({
    _id: [],
    userType: "Admin",
    sortingType: "",
    sortingField: "",
    userStatus: "All",
    durationDate: "",
    fromDate: "",
    toDate: "",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    searchParameterList: ['fullNameString.fullName', 'userStatus', 'role', 'userType', 'emailAddress'],
    userID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?._id,
  });

  if (sessionStorage.getItem('LOGIN_DETAILS') !== undefined && sessionStorage.getItem('LOGIN_DETAILS') != null) {
    LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
    values.userID = LOGIN_DETAILS._id;
  }

  useEffect(() => {
    (async () => {
      let duration = new URLSearchParams(window.location.search).get('duration');
      let customFrom = new URLSearchParams(window.location.search).get('from');
      let customTo = new URLSearchParams(window.location.search).get('to');
      duration && (values.durationDate = duration)
      customFrom && (values.fromDate = customFrom)
      customTo && (values.toDate = customTo)
      await getRight();
      await fetchUserData();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.userStatus, values.sortingType, perPage, dispatch]);


  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };


  const handleDeleteDialogeClick = async (_id) => {
    if (LOGIN_DETAILS._id === _id) {
      showResMsg(genericMessage.logusercantdeleted, 2000, false);
      return
    }
    values._id = []
    values._id.push(_id)
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleDelete = async (id) => {
    deleteUser();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = page => {
    values.page = page;
    fetchUserData();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    dispatch(loadingAction(true));
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
    dispatch(loadingAction(false));
  };

  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };

  const deleteUser = async () => {
    await deleteUserRecords(values, (data) => {
      fetchUserData();
      setTitle("");
      showResMsg(data.Result_Status ? genericMessage.deleted : data.Result_Message, 1000, data.Result_Status);
    }, dispatch)
  };

  async function getRight() {
    let right = await getScreenRight("Users")
    if (right === "Full Access") setDisableColor(false)
    else setDisableColor(true)
  }

  const changeCustomerReload = () => {
    setCustomerReload(!customerReload);
  };

  useEffect(() => {
    userStatus = values.userStatus;
    changeCustomerReload();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  const fetchUserData = async () => {
    values.searchParameter = searchParameter;
    values.userStatus = userStatus;

    await fetchUser(values, (data) => {
      setTotalRows(data.Result_Output.totalDocs);
      setRows(data.Result_Output.docs)
    }, dispatch)
  };

  let columns = [
    {
      name: "Name",
      selector: row => row.fullNameString.fullName,
      sortable: true,
      sortField: 'fullNameString.fullName',
    },
    {
      // name: "Email Address",
      name: <p style={{ paddingLeft: "12px" }}>Email Address</p>,
      selector: row => row.emailAddress,
      sortable: true,
      sortField: 'emailAddress',
      center: true,
    },
    {
      // name: "User Type",
      name: <p style={{ paddingLeft: "12px" }}>User Type</p>,
      selector: row => row.userType,
      sortable: true,
      sortField: 'userType',
      center: true,
    },
    {
      // name: "Role",
      name: <p style={{ paddingLeft: "12px" }}>Role</p>,
      selector: row => row.role,
      sortable: true,
      sortField: 'role',
      center: true,
    },
    {
      // name: "Status",
      name: <p style={{ paddingLeft: "12px" }}>Status</p>,
      selector: row => row.userStatus,
      sortable: true,
      sortField: 'userStatus',
      center: true,
    },
    {
      name: "Actions",
      selector: row => row._id,
      center: true,
      cell: (row) => (
        <>
          <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}>
            <Grid item>
              <Link
                to={`/users/edit/${row._id}`}
              >
                <TimelineItem color="success" icon="edit" title="Edit" />
              </Link>
            </Grid>
            <Grid item >
              <TimelineItem
                color="error"
                icon="delete"
                onClick={() => handleDeleteDialogeClick(row._id)}
                title="Delete"
              />
            </Grid>

          </Grid>
        </>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar screenName='Users' />

      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName="Users" />
          <Grid container display={"flex"} justifyContent="end" mt={2.2} gap={2} >
            <Grid lg={2.5} xs={6} >
              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "44.11px" }}
                  label="Filter By Status"
                  value={values.userStatus}
                  onChange={(e) => setValues({ ...values, userStatus: e.target.value })}
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6}>
              <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") fetchUserData();
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment  >
                      <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchUserData}>
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <div style={{ marginRight: '16px' }}>
              <Link to={"/users/new"}>
                <MDButton
                  variant="contained"
                  className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                  color={disableColor ? "secondary" : "success"} style={{ height: "44.11px", width: "99px" }} >
                  Add New
                </MDButton>
              </Link>
            </div>
          </Grid>
          <CardContent>
            <BTable
              title={title}
              columns={columns}
              data={rows}
              selectableRows={false}
              sortingType={handleSort}
              sortServer
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              fixedHeaderScrollHeight="410px"
              fixedHeader={true}

            />
          </CardContent>
        </Card>
      </div >
      <DeleteModal
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}

      />
    </DashboardLayout>
  );
}

export default Users;
